import { render } from "./ClasificationForm.vue?vue&type=template&id=1b1f7c1e&scoped=true"
import script from "./ClasificationForm.vue?vue&type=script&lang=js"
export * from "./ClasificationForm.vue?vue&type=script&lang=js"

import "./ClasificationForm.vue?vue&type=style&index=0&id=1b1f7c1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1f7c1e"]])

export default __exports__